// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components----signup-module---root---eOHh5","error":"src-components----signup-module---error---2auyC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/signup.module.css
// module id = 75
// module chunks = 35783957827783 133642133980541